import { useCallback, useRef, useContext } from 'react'
import { stateContext } from './ctx'
import Dot from './Dot'

const Dots = () => {
    const {schema,session,hue,setSchema} = useContext(stateContext)

    const dragger = useRef(null)


    const printDots = useCallback(()=>{
        if (dragger && dragger.current){
            const draggerContainer = dragger.current.getBoundingClientRect()
            const {width,height} = draggerContainer
            return schema ? schema.map((o,k)=><Dot idx={k} parent={dragger.current} hue={hue} width={width} height={height} key={k} />) : []
        } else {
            return <div>Empty...</div>
        }
    },[dragger,schema,session,hue])

    return <div ref={dragger} className='group-hover:opacity-100 opacity-0 transition duration-500 flex relative h-full flex-1 z-20'>
      {printDots()}
    </div>
}

export default Dots